import {
  SET_PENDING_USERS,
} from '../actions/pending.users';

let initialState = {
  pendingUsersData: [],
};

const pendingUsers = (state = initialState, action) => {
  switch (action.type) {
    case SET_PENDING_USERS:
      return {
        ...state,
        pendingUsersData: action.payload,
      };

    default:
      return state;
  }
};

export default pendingUsers;
